import React, { useEffect, useCallback } from "react";
import LoadingPage from '../../../components/LoadingPage'; 
import EnvService from "../../../services/env.service";
import RequestService from "../../../services/request.service";
import UrlService from "../../../services/url.service";
import { showDialogErrorMessage } from "../../../services/error-handling.service";

export default function Callback() {

  const { REACT_APP_AUTH_SIMPLE_LOGIN_USER_URL } = EnvService.getEnv();

  const loadUserToCookie = useCallback(async () => {
    const redirectUrl = UrlService.getQueryString("redirect_app_url");

    try {
      await RequestService.get(`${REACT_APP_AUTH_SIMPLE_LOGIN_USER_URL}`);
      window.location.href = redirectUrl;
    } catch(e) {
      const message = e.response?.data?.message;
      if (message) {
        showDialogErrorMessage(message);
      }
    }

  }, [REACT_APP_AUTH_SIMPLE_LOGIN_USER_URL]);

  useEffect(loadUserToCookie, [loadUserToCookie]);

  return <LoadingPage />
}